import React, { useState } from "react";
import Header from "../include/Header";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomBreadcrumb from "../include/Breadcrumb";
import axios from "axios";
import { API_URL } from "../config/api";
function Register() {

  // ===========================
  // 🧠 NAVIGATION (PAGE CHANGE)
  // ===========================
  const navigate = useNavigate();

  // ===========================
  // 🧠 FORM STATE (DATA STORAGE)
  // ===========================
  const [formData, setFormData] = useState({
    name: "",      // user name
    email: "",     // user email
    password: "",  // user password
  });

  // ===========================
  // ✍️ INPUT CHANGE HANDLER
  // ===========================
  const handleChange = (e) => {

    setFormData({
      ...formData,                 // old data copy
      [e.target.name]: e.target.value, // new value update
    });

  };

  // ===========================
  // 🚀 FORM SUBMIT (REGISTER API)
  // ===========================
//   const handleSubmit = async (e) => {

//     e.preventDefault(); // page reload stop

//     try {

//       // send data to Laravel API
//    const res = await axios.post(
//   `${API_URL}/register`,
//   formData
// );
// console.log(API_URL);
//       // console.log(res.data);

//       alert("Registration Successful");

//       // reset form after success
//       setFormData({
//         name: "",
//         email: "",
//         password: "",
//       });

//       // redirect to login page
//       navigate("/login");

//     } catch (error) {
// console.log(API_URL);
//       console.log(error.response?.data);

//       alert("Registration Failed");
//     }
//   };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    console.log("API URL:", `${API_URL}/register`);
const res = await axios.post(
  `${API_URL}/register`,
  formData,
  {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }
);

    alert(res.data.message || "Registration Successful");

    setFormData({
      name: "",
      email: "",
      password: "",
    });

    navigate("/login");
  } catch (error) {
    console.log("API URL:", `${API_URL}/register`);
    console.log("Status:", error.response?.status);
    console.log("Response:", error.response?.data);
    console.log("Error:", error.message);

    alert(error.response?.data?.message || "Registration Failed");
  }
};



  // ===========================
  // 🖥️ UI START
  // ===========================
  return (
    <>
      <Header />

      <div className="ved">

        <Container className="my-5">

          <CustomBreadcrumb title="Register" />

          <Row className="justify-content-center align-items-center shadow-lg rounded overflow-hidden bg-white">

            {/* ===========================
                🖼️ LEFT SIDE IMAGE
            =========================== */}
            <Col md={6} className="p-0">

              <img
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=900"
                alt="Register"
                className="img-fluid h-100"
              />

            </Col>

            {/* ===========================
                🧾 RIGHT SIDE FORM
            =========================== */}
            <Col md={6}>

              <div className="p-5">

                <h2 className="fw-bold mb-2">
                  Create Account
                </h2>

                <Form onSubmit={handleSubmit}>

                  {/* NAME */}
                  <Form.Group className="mb-3">
                    <Form.Label>Full Name</Form.Label>

                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      size="lg"
                      required
                    />
                  </Form.Group>

                  {/* EMAIL */}
                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>

                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      size="lg"
                      required
                    />
                  </Form.Group>

                  {/* PASSWORD */}
                  <Form.Group className="mb-4">
                    <Form.Label>Password</Form.Label>

                    <Form.Control
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter password"
                      size="lg"
                      required
                    />
                  </Form.Group>

                  {/* SUBMIT BUTTON */}
                  <Button
                    type="submit"
                    variant="primary"
                    className="w-100 py-2"
                    size="lg"
                  >
                    Create Account
                  </Button>

                  {/* LOGIN LINK */}
                  <div className="text-center mt-4">
                    Already have an account?{" "}

                    <Link
                      to="/login"
                      className="text-decoration-none fw-semibold"
                    >
                      Login
                    </Link>

                  </div>

                </Form>

              </div>

            </Col>

          </Row>

        </Container>

      </div>

    </>
  );
}

export default Register;